import { WriteHook, useMutationManager } from 'react-query-state-manager'

import { revertApplicationToDocumentRequest } from '../service'

export const useRevertToDocumentRequest: WriteHook<{ id: number; notes: string }, void> = (opts) =>
  useMutationManager(revertApplicationToDocumentRequest, opts)
